import { Metadata } from './Metadata';

export class Upsell {
    cost: string;
    id: number;
    maxquantity: number;
    minquantity: number;
    name: string;
    shortdescription: string;
    image: string | undefined;
    chainproductid?: number;
    source: string;
    metadata?: Array<Metadata> | null;
}
